import { getActiveLanguage } from "laravel-vue-i18n";

export function getTranslatedValue(item, field) {
    const activeLanguage = getActiveLanguage();

    return activeLanguage === 'nl'
        ? item[field]
        : item.translations.find(t => t.language === activeLanguage)?.[field] || item[field];
}
